import { render, staticRenderFns } from "./FilesDialog.vue?vue&type=template&id=783f5d8a&"
import script from "./FilesDialog.vue?vue&type=script&lang=js&"
export * from "./FilesDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports